import { useRef, useState } from 'react';
import { If } from '../Atoms/Conditionals';
import { scrollIntoView } from '../Common/navigation/utils';
import { Heading, HeadingType } from '../Typography';
import { AdvanceTaxData } from './Atc-calculator-constants';
import { AtcTaxSummary } from './atc-tax-summary';
import TabComponent from './tab-switch-section';
import { CALCULATOR_DATA } from './types';

export const AtcTaxCalculator = () => {
  const [showCalculation, setShowCalculation] = useState({
    displayCalculation: false,
    renderCalculation: false,
  });

  const taxWrapper = useRef<HTMLDivElement>(null);
  const calculationFieldsWrapper = useRef<HTMLDivElement>(null);

  const [hasError, setGlobalError] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [inputTabData, setInputData] = useState<CALCULATOR_DATA>({
    AgeGroup: 'NotSenior',
    EntityType: 'Individual',
    ResidentialStatus: 'Resident',
  });

  const commonProps = {
    hasError: hasError,
    setGlobalError: setGlobalError,
    inputTabData: inputTabData,
    setInputData: setInputData,
    showCalculation: showCalculation,
    setShowCalculation: setShowCalculation,
    taxWrapper: taxWrapper.current,
  };

  const handleRecalculate = () => {
    if (calculationFieldsWrapper.current) {
      scrollIntoView(calculationFieldsWrapper.current, 70);
    }
  };

  return (
    <>
      <div
        className={`p-12 md:p-2.5 shadow-lg bg-white mb-6 sm:py-6 sm:px-[10px] rounded-md ${
          showCalculation.displayCalculation ? 'block' : 'h-0 hidden'
        }`}
        style={{
          boxShadow: '0px 0px 30px 0px #1678FB1A',
        }}
        id="Atc-calculation"
        ref={taxWrapper}
      >
        <If condition={showCalculation.displayCalculation}>
          <div className="flex justify-between items-baseline cursor-pointer mb-6 text-s-18 font-bold">
            <h3 className="text-s-24 md:text-base font-bold text-font-500 sm:pb-3">
              Summary
            </h3>
            <div
              className="text-blue-350 text-s-16 font-medium"
              onClick={handleRecalculate}
            >
              &#8595; &nbsp; Recalculate
            </div>
          </div>
          <AtcTaxSummary
            inputTabData={inputTabData}
            renderCalculation={showCalculation.renderCalculation}
          />
        </If>
      </div>
      <div
        className="p-12 sm:p-6 bg-white my-6"
        style={{
          boxShadow: '0px 0px 30px 0px #1678FB1A',
        }}
        ref={calculationFieldsWrapper}
      >
        <If condition={showCalculation.displayCalculation}>
          <Heading
            variant={HeadingType.h6}
            content="Recalculate"
            className="mb-6 sm:mb-2 sm:ml-2"
          />
        </If>
        <TabComponent
          tabsData={AdvanceTaxData}
          defaultActiveTab={AdvanceTaxData?.tabs[0]?.index || 0}
          commonProps={commonProps}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </>
  );
};
